import { FormikProps } from 'formik'
import { FormTextArea } from '../../../../../../../components'

import { FC } from 'react'
import { ResultFormIA } from './ResultadoIAModal'

type IOrientacoesIAModal = {
  formik: FormikProps<ResultFormIA>
  onReset: () => void
}

export type OrientacoesIA = {
  titulo: string
  orientacoes: string
}

export const OrientacoesIAModal: FC<IOrientacoesIAModal> = ({ formik, onReset }) => (
  <>
    <FormTextArea
      name='orientacoes_medicas.titulo'
      placeholder='Digite o título'
      formik={formik}
      onReset={onReset}
      rows={1}
      className='mb-3'
      label='Título'
      isRequired
    />

    <FormTextArea
      name='orientacoes_medicas.orientacoes'
      placeholder='Digite as Orientações Médicas'
      formik={formik}
      onReset={onReset}
      label='Orientações'
      isRequired
    />
  </>
)
